<template>
  <div class="container is-fluid">
    
    <h1 class="title">Add a New User</h1>
    <div class="box ">	
      
      <div class="columns">
        <div class="field column">
          <label class="label">Forename</label>
          <div class="control">
            <input class="input" type="text" placeholder="" v-model="user.forename" required>
          </div>
        </div>
        <div class="field column">
          <label class="label">Surname</label>
          <div class="control">
            <input class="input" type="email" placeholder="" v-model="user.surname" required>
          </div>
        </div>
      </div>
       <div class="columns">
        <div class="field column">
           <label class="label">Email</label>
          <div class="control">
            <input class="input" type="email" placeholder="" v-model="user.email" required>
          </div>
        </div>
        <div class="field column">
         
        </div>
      </div>

       <div class="columns">
        <div class="field column">
          <label class="label">Governing Body</label>
          <div class="select is-fullwidth">
              <select  v-model="user.governing_body_id" required>
                  <option value="">Please select</option>
                  <option v-for="row in governing_bodies" :key="row.id" :value="row.id">{{ row.name }}</option>
                  <option value="0">MPT User or Director (no sport required)</option>
              </select>
              
              
          </div>
       
        </div>
      </div>

      <div class="field ">
            <label class="label">Type of User</label>
              <div class="control columns">
                <div class="column">
                  <label class="checkbox">
                    <input type="checkbox" name="roles" value="rol_oX8nZnCuCJyPGIDJ" v-model="user.roles">
                    Liaison Officer
                  </label>
                </div>
                <div class="column">
                  <label class="checkbox">
                    <input type="checkbox" name="roles" value="rol_98712jwlXkGeg27i" v-model="user.roles">
                    Admin
                  </label>
                </div>
                <div class="column">
                  <label class="checkbox">
                    <input type="checkbox" name="roles" value="rol_DAwmtHPRbGTTAy1Z" v-model="user.roles">
                    Director
                  </label>
                </div>
                
              </div>
          </div>
     
      <div class="field is-grouped">
        <p class="control">
          <a class="button is-success" :disabled="working===1" @click.prevent="saveUser()">
            Save User
          </a>
         
        </p>
       
      </div>


    </div>
	     

  </div>
</template>

<script>

import ApplicationService from '@/services/ApplicationService.js';
import UserService from '@/services/UserService.js';

export default {
  name:'AddUser',
  components: {
   	
  },
  data() {
    return {
      errors: [],
      user: { "forename" : "",
      "surname": "",
      "governing_body_id": '',
      "email" : "" ,
      roles: []
      },
      governing_bodies: [],
      accessToken: '',
      working:0
     
    }
  },
  

  // Fetches posts when the component is created.
  created() {
    this.getAccessToken()
    .then(() => { 
      this.getGoverningBodies();
    });
  },
  methods: {
     async getAccessToken() {
      this.accessToken = await this.$auth.getTokenSilently()
    },
    async getGoverningBodies() {
      
      ApplicationService.getGoverningBodies(this.accessToken)
      .then(
        (governing_bodies => {
          this.$set(this, "governing_bodies", governing_bodies);
        }).bind(this)
      );
    },
    async saveUser() {
        this.working = 1
        UserService.saveUser(this.accessToken, this.user)
        .then(
          (() => {
            this.$router.push("/users");
          })
          
        );
      }
    }
    
}

</script>

<style>
	
</style>
